export default function TermsOfService() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 prose prose-sm">
      <h1 className="text-2xl font-bold text-ink-900 mb-2">Brukervilkår</h1>
      <p className="text-[12px] text-ink-500">Sist oppdatert: 7. april 2026</p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">1. Tjenesten</h2>
      <p className="text-[13px] text-ink-700">
        Contrack er en SaaS-tjeneste for AI-drevet fakturakontroll i byggebransjen.
        Tilgang gis basert på abonnement.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">2. Abonnement</h2>
      <p className="text-[13px] text-ink-700">
        Abonnement gjelder per måned, med 30 dagers oppsigelse. Pris og plan-grenser
        defineres i den valgte planen (Starter, Vekst, Enterprise).
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">3. Bruk og ansvar</h2>
      <p className="text-[13px] text-ink-700">
        Brukeren er ansvarlig for å sikre at lastede dokumenter er lovlig oppnådd og at
        AI-analyser verifiseres av kvalifisert personell før godkjenning. Contrack gir
        ikke juridiske anbefalinger.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">4. Tilgjengelighet</h2>
      <p className="text-[13px] text-ink-700">
        Vi tilstreber 99.5% oppetid (Starter/Vekst) og 99.9% (Enterprise SLA).
        Planlagte vedlikeholdsvinduer varsles minst 24 timer i forveien.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">5. Datasikkerhet</h2>
      <p className="text-[13px] text-ink-700">
        Data lagres i Microsoft Azure (Europa). Kryptering i transit (TLS 1.2+) og
        i hvile (AES-256). Daglige backups med 30 dagers retention.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">6. Endringer</h2>
      <p className="text-[13px] text-ink-700">
        Vi forbeholder oss retten til å endre disse vilkårene. Vesentlige endringer varsles
        via e-post minst 30 dager før de trer i kraft.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">7. Lov og verneting</h2>
      <p className="text-[13px] text-ink-700">
        Norsk lov gjelder. Verneting er Oslo tingrett.
      </p>
    </div>
  );
}
